import { Component } from '@angular/core';
import { InitialLoaderMaterialModule } from './initial-loader-material-modules.module';

@Component({
    selector: 'app-initial-loader',
    standalone: true,
    imports: [InitialLoaderMaterialModule],
    templateUrl: './initial-loader.component.html',
    styleUrl: './initial-loader.component.scss',
})
export class InitialLoaderComponent {}
